import Navbar from "./components/Navbar";
import { ThemeProvider } from "./context/ThemeContext";
//import Hero from "./components/Hero"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DoctorList from "./pages/DoctorList";
import UserLogin from "./pages/UserLogin";
import DoctorLogin from "./pages/DoctorLogin";
import UserRegister from "./pages/UserRegister";
import DoctorRegister from "./pages/DoctorRegister";
import DoctorDashboard from "./pages/DoctorDashboard";
import UserDashboard from "./pages/UserDashboard";
import Footer from "./components/Footer";
import DoctorDetails from "./pages/DoctorDetails";
import BookAppointmentPage from "./pages/BookAppointmentPage";
import Home from "./pages/Home";
import AIAssistant from "./pages/AIAssistant";
const App = () => {
  return (
   <ThemeProvider>
      <Router>
        <div className="bg-gray-50 dark:bg-gray-950 min-h-screen text-gray-900 dark:text-white">
          <Navbar />
        
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/doctors" element={<DoctorList />} />
             <Route path="/login/user" element={<UserLogin />} />
            <Route path="/login/doctor" element={<DoctorLogin />} />
            <Route path="/register/user" element={<UserRegister />} /> {/* <-- Add this line */}
            <Route path="/register/doctor" element={<DoctorRegister />} /> {/* <-- Add this line */}
            <Route path="/doctor/dashboard" element={<DoctorDashboard/>} />
            <Route path="/user/dashboard" element={<UserDashboard/>} />
            <Route path="/doctors/:id" element={<DoctorDetails />} />
            <Route path="/book-appointment/:doctorId" element={<BookAppointmentPage />} />
            <Route path="/ai-assistant" element={<AIAssistant />} />


          </Routes>
        </div>
        <Footer />
      </Router>
    </ThemeProvider>
  )
}

export default App